<div
  class="flex flex-col relative"
  [class.w-full]="type() === 'list'"
  [class.gap-lg]="type() === 'list'">
  @if (type() === 'list') {
    @for (
      file of uploadedFiles();
      track file?.id;
      let i = $index;
      let last = $last
    ) {
      <ng-container
        [ngTemplateOutlet]="fileItem"
        [ngTemplateOutletContext]="{ $implicit: file, last: last }">
      </ng-container>
    }
  } @else {
    @if (type() === 'input') {
      <label class="text-neutral-500 font-medium text-xs2">
        {{ label() }}
      </label>
    }

    <div
      class="flex items-center"
      [class.gap-5xl]="type() === 'input'"
      [class.gap-x-sm]="type() === 'icon'"
      [class.py-x-sm]="type() === 'icon'"
      [class.px-sm]="type() === 'icon'"
      [class.bg-primary-50]="type() === 'icon'"
      [class.rounded-sm]="type() === 'icon'">
      @if (type() === 'icon') {
        <lib-attachment-icon [iconClass]="'size-6 text-primary-500'" />
      }

      <p
        class="view-mode-value break-word"
        [class.text-primary-500]="type() === 'icon'"
        [class.text-neutral-900]="type() === 'input'">
        {{ uploadedFiles().length }}
        {{
          uploadedFiles().length > 1
            ? uploadFileLabels().multipleFilesUploadedLabel
            : uploadFileLabels().singleFileUploadedLabel
        }}
      </p>

      @if (uploadedFiles() && uploadedFiles().length) {
        <button
          type="button"
          class="bg-transparent cursor-pointer flex"
          (click)="toggleMenu()">
          <lib-chevron-down-icon
            iconClass="size-5"
            [stroke]="
              type() === 'icon'
                ? 'var(--color-primary-500)'
                : 'var(--color-neutral-500)'
            " />
        </button>
      }
    </div>
  }

  @if (isMenuOpen()) {
    <div
      class="top-full w-full flex flex-col absolute bg-white shadow-md rounded-xl items-center gap-2xl p-2xl max-h-[29.5rem] min-w-[21.75rem] overflow-y-auto z-1">
      <div class="flex items-center justify-between w-full">
        <div class="font-medium text-lg text-neutral-900">
          {{ uploadFileLabels().attachmentsTitle }}
        </div>

        <div class="flex cursor-pointer" (click)="isMenuOpen.set(false)">
          <lib-close-icon
            iconClass="size-6"
            stroke="var(--color-neutral-500)" />
        </div>
      </div>

      @for (
        file of uploadedFiles();
        track file?.id;
        let i = $index;
        let last = $last
      ) {
        <ng-container
          [ngTemplateOutlet]="fileItem"
          [ngTemplateOutletContext]="{ $implicit: file, last: last }">
        </ng-container>
      }
    </div>
  }
</div>

<ng-template #fileItem let-file let-last="last">
  <a
    class="w-full flex justify-between items-center text-sm text-neutral-900 hover-state pb-lg border-neutral-200"
    [class.border-b]="!last && type() === 'list'"
    [href]="file?.url"
    target="_blank">
    <div class="flex">
      <div class="flex">
        <lib-file-icon iconClass="size-8 text-primary-500" />
      </div>

      <div class="flex flex-col gap-sm trim-width ms-md me-2xl">
        <span class="text-base text-neutral-900 trim-file-name font-normal">
          {{ file?.name | truncate: 22 }}
        </span>

        @if (file?.size) {
          <span class="text-sm text-neutral-500 font-normal">
            {{ file?.size }}KB
          </span>
        }
      </div>
    </div>

    <div class="flex">
      <lib-file-download-icon
        iconClass="size-8"
        stroke="var(--color-primary-500)" />
    </div>
  </a>
</ng-template>
